module.exports = __webpack_public_path__ + "img/Pic_DDZ_PT.47aae3bb.png";